import { render, staticRenderFns } from "./index.vue?vue&type=template&id=64db42c7&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=64db42c7&scoped=true&lang=css&"
import style1 from "./index.vue?vue&type=style&index=1&id=64db42c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64db42c7",
  null
  
)

export default component.exports